import { Grid } from '@mui/material'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { useDashboardContext } from '../providers/contexts/Dashboard'
import { ROUTES } from '../utils/constants/enum'
import { GENERATE_POLICY_LINK } from '../utils/helper-functions'
import { useLocalState } from '../utils/local-storage'
import { TERMS } from './_nav'

import './footer.scss'

const AccountFooter = (props: any) => {
    const { userData } = useDashboardContext((state) => ({
        userData: state.userData,
    }))
    const { status } = props
    const { t } = useTranslation()
    const CURRENT_YEAR = moment().format('YYYY')
    const [language] = useLocalState<string>('i18nextLng', true)

    return (
        <>
            {status && (
                <footer>
                    <hr />
                    <div className="wrapper acc">
                        <h6>Hydrafacial.com</h6>
                        <hr />
                        <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item>
                                <a
                                    href={GENERATE_POLICY_LINK(
                                        language as string,
                                        ROUTES.PRIVACY
                                    )}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t('common_elements.privacy_policy_link')}
                                </a>
                                &nbsp;&nbsp;
                                {userData?.country === 'us' ||
                                userData?.country === 'ca' ? (
                                    <a
                                        href={`${ROUTES.TERMS_AND_CONDITIONS}en`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {t(
                                            'common_elements.terms_conditions_link'
                                        )}
                                    </a>
                                ) : (
                                    <a
                                        href={TERMS.link}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {t(
                                            'common_elements.terms_conditions_link'
                                        )}
                                    </a>
                                )}
                            </Grid>
                            <Grid item>
                                <p>
                                    {t('common_elements.copyright_text', {
                                        current_year: CURRENT_YEAR,
                                    })}
                                </p>
                            </Grid>
                        </Grid>
                    </div>
                </footer>
            )}
        </>
    )
}

export default AccountFooter
